import { Link } from "@inertiajs/react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { bizminer_app_pillar_insight_scoring_category_path } from "@/routes";
import type { CategoryWithPeers } from "../../_components/scoring-types";

interface CategoryScoresSidebarProps {
  categoriesWithPeers: CategoryWithPeers[];
  activeCategoryId: string;
  pillarInsightId: number;
}

export function CategoryScoresSidebar({
  categoriesWithPeers,
  activeCategoryId,
  pillarInsightId,
}: CategoryScoresSidebarProps) {
  return (
    <Card>
      <CardHeader className="px-4 pt-2 pb-0">
        <CardTitle className="text-sm text-muted-foreground">
          Category Scores
        </CardTitle>
      </CardHeader>
      <CardContent className="p-0 pb-1">
        <ul>
          {categoriesWithPeers.map((cat) => {
            const isActive = cat.id === activeCategoryId;
            return (
              <li key={cat.id}>
                {isActive ? (
                  <div
                    className={cn(
                      "h-[30px] w-full flex items-center justify-between px-4 text-sm",
                      "bg-primary/8 text-primary font-semibold cursor-default",
                    )}
                  >
                    <span className="truncate pr-2 text-left">{cat.name}</span>
                    <span className="tabular-nums shrink-0 font-medium">
                      {cat.account_score.toFixed(1)}
                    </span>
                  </div>
                ) : (
                  <Link
                    href={bizminer_app_pillar_insight_scoring_category_path(
                      pillarInsightId,
                      cat.id,
                    )}
                    className={cn(
                      "h-[30px] w-full flex items-center justify-between px-4 text-sm transition-colors",
                      "text-muted-foreground hover:bg-muted/50 hover:text-foreground",
                    )}
                  >
                    <span className="truncate pr-2 text-left">{cat.name}</span>
                    <span className="tabular-nums shrink-0 font-medium">
                      {cat.account_score.toFixed(1)}
                    </span>
                  </Link>
                )}
              </li>
            );
          })}
        </ul>
      </CardContent>
    </Card>
  );
}
